
// ------------- old code ----------------------
// import React, { useEffect, useState } from 'react'
// import { Link, useNavigate } from 'react-router-dom'
// import ImageWithBasePath from '../../../core/common/imageWithBasePath'
// import { all_routes } from '../../router/all_routes'
// import CollapseHeader from '../../../core/common/collapse-header/collapse-header'
// import PredefinedDateRanges from '../../../core/common/datePicker'
// import Table from "../../../core/common/dataTable/index";
// // import AXIOSCONFIGMETHOD from "../../../Axios/axiosConfigMethod";
// import AXIOSCONFIGMETHOD from '../../../Axios/axiosConfigMethod'
// // import { webServiceUrl } from "../../../core/api_utils/webserviceUrl";
// import { webServiceUrl } from '../../../core/api_utils/webserviceUrl'
// // import { leadsDataList } from '../../../core/data/json/leadsList'
// // import CrmsModal from '../../../core/modals/crms_modal'
// import { leadsDataList } from '../../../core/data/json/leadsList'
// import axios from 'axios';
// // import '../../../Loader';
// // import CustomeLoader from '../../../core/common/customeLoader/CustomeLoader'
// import Loading from  '../../../core/common/custom-loading/Loading'
// // import Loader from '../../../Loader'

import { useEffect, useState } from "react";
import AXIOSCONFIGMETHOD from "../../../Axios/axiosConfigMethod";
import { webServiceUrl } from "../../../core/api_utils/webserviceUrl";
import { useNavigate, useParams } from "react-router";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import Loading from "../../../core/common/custom-loading/Loading";
import Table from "../../../core/common/dataTable/index";
import { ColumnsType } from "antd/es/table";

export interface StaffActivity {
    lead_account_id: number;
    name: string;
    mobile_no: string;
    email_id: string;
    locality: string;
    city: string;
    state: string;
    source_type: string;
    current_stage: string;
    created_on: string;
    followup_name: string;
    followup_comments: string;
    next_followup_date: string | null;
    next_followup_time: string | null;
    scheduled_meeting_date: string | null;
    scheduled_meeting_time: string | null;
    scheduled_meeting_location: string | null;
    expected_closing_date: string | null;
}



const ViewMemberActivities = () => {
    const [loading, setLoading] = useState<any>(false)
    const [state, setState] = useState<any>([]);
    const { organization_user_id } = useParams()
    // console.log("vcvvvvvvvvvvvvvvvvvvvvvvvvvvvvv", state)
    // const getAllLead = async () => {
    //   try {
    //     setLoading(true);
    //     const response = await AXIOSCONFIGMETHOD("post", webServiceUrl.ALL_LEAD_LIST);
    //     // console.log("Response:", response?.data?.data);
    //     setState(response?.data);
    //   } catch (error) {
    //     console.error("Error fetching leads:", error);
    //   }
    //   setLoading(false);
    // };


    const getStaffActivities = async () => {
          const payload = {
            sales_user_id: organization_user_id,
        };
        try {
            console.log("This is payload :",payload);
            
            setLoading(true);
            const response = await AXIOSCONFIGMETHOD("post",
                webServiceUrl.VIEW_STAFF_RECENT_ACTIVITIES,
                payload);
            console.log("nnnnnnccc", response)
            if (response?.success) {
                setState(response?.data);
            } else {
                console.error("API responded with failure:", response?.data?.message);
            }
        } catch (error: any) {
            console.error("Error fetching leads:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        getStaffActivities();
    }, []);


    const navigate = useNavigate();
    const routes = all_routes;
    // const data = leadsDataList;
    //   const columns = [
    //     {
    //       title: "Lead Name",
    //       dataIndex: "lead_name",
    //       sorter: (a: any, b: any) => a.lead_name.length - b.lead_name.length,

    //       // title: "Lead Name",
    //       // dataIndex: "LeadName",
    //       // render: (text: string) => (
    //       //   <div className="">
    //       //     <Link to={routes.leadsDetails}>{text}</Link>
    //       //   </div>
    //       // ),
    //       // sorter: (a: any, b: any) => a.LeadName.length - b.LeadName.length,
    //     },
    //     {
    //       title: "Sales Owner",
    //       dataIndex: "sales_owner",
    //       sorter: (a: any, b: any) => a.sales_owner.length - b.sales_owner.length,

    //       // title: "Sales Owner",
    //       // dataIndex: "SalesOwner",
    //       // render: (text: string, record: any) => (
    //       //   <div className="d-flex align-items-center file-name-icon">

    //       //     <div className="ms-2">
    //       //       <div className="">
    //       //         <Link to={routes.companiesDetails}>{text}</Link>
    //       //       </div>
    //       //     </div>
    //       //   </div>
    //       // ),
    //       // sorter: (a: any, b: any) => a.SalesOwner.length - b.SalesOwner.length,
    //     },
    //     {
    //       title: "Type",
    //       dataIndex: "type",
    //       sorter: (a: any, b: any) => a.type.length - b.type.length,
    //     },
    //     {
    //       title: "Stage",
    //       dataIndex: "stage",
    //       render: (text: string) => (
    //         <span
    //           className={`badge ${
    //             text === "WON"
    //               ? "badge-success-transparent"
    //               : text === "FOLLOWUP"
    //               ? "badge-warning-transparent"
    //               : text === "LOST"
    //               ? "badge-danger-transparent"
    //               : "badge-secondary-transparent"
    //           }`}
    //         >
    //           {text}
    //         </span>
    //       ),
    //       sorter: (a: any, b: any) => a.stage.length - b.stage.length,
    //     },
    // {
    //   title: "Assigned On",
    //   dataIndex: "assigned_on",
    //   render: (text: string) => {
    //     if (!text) return "-";

    //     const date = new Date(text);
    //     if (isNaN(date.getTime())) return "-"; // handle invalid dates

    //     const day = String(date.getDate()).padStart(2, "0");
    //     const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    //     const year = date.getFullYear();

    //     return <p className="text-capitalize">{`${day}-${month}-${year}`}</p>;
    //   },
    //   sorter: (a: any, b: any) => {
    //     const dateA = new Date(a.assigned_on || 0).getTime();
    //     const dateB = new Date(b.assigned_on || 0).getTime();
    //     return dateA - dateB;
    //   },
    // },

    //     {
    //       title: "Mobile No",
    //       dataIndex: "mobile_no",
    //       sorter: (a: any, b: any) => a.mobile_no.length - b.mobile_no.length,
    //     },
    //     {
    //       title: "Email",
    //       dataIndex: "email_id",
    //       sorter: (a: any, b: any) => a.email_id.length - b.email_id.length,
    //     },
    //     {
    //       title: "Gender",
    //       dataIndex: "gender",
    //       sorter: (a: any, b: any) => a.gender.length - b.gender.length,
    //     },
    //     {
    //       title: "Locality",
    //       dataIndex: "locality",
    //       sorter: (a: any, b: any) => a.locality.length - b.locality.length,
    //     },
    //     {
    //       title: "City",
    //       dataIndex: "city",
    //       sorter: (a: any, b: any) => a.city.length - b.city.length,
    //     },
    //     {
    //       title: "State",
    //       dataIndex: "state",
    //       sorter: (a: any, b: any) => a.state.length - b.state.length,
    //     },
    //     {
    //       title: "Source",
    //       dataIndex: "source",
    //       sorter: (a: any, b: any) => a.source.length - b.source.length,
    //     },
    //     {
    //       title: "Product",
    //       dataIndex: "product",
    //       sorter: (a: any, b: any) => a.product.length - b.product.length,
    //     },
    //     {
    //   title: "Min Budget",
    //   dataIndex: "min_budget",
    //   key: "min_budget",
    //   render: (value: number) => (value ? `₹${value.toLocaleString("en-IN")}` : "-"),
    //   sorter: (a: any, b: any) => (a.min_budget || 0) - (b.min_budget || 0),
    // },
    // {
    //   title: "Max Budget",
    //   dataIndex: "max_budget",
    //   key: "max_budget",
    //   render: (value: number) => (value ? `₹${value.toLocaleString("en-IN")}` : "-"),
    //   sorter: (a: any, b: any) => (a.max_budget || 0) - (b.max_budget || 0),
    // },

    //     // {
    //     //   title: "Expected Close Date",
    //     //   dataIndex: "expected_close_date",
    //     //   sorter: (a: any, b: any) => a.expected_close_date.length - b.expected_close_date.length,
    //     // },

    //     {
    //       title: "Trails",
    //       dataIndex: "FollowupTrail",
    //       width: 150, // Set width in pixels (adjust as needed)
    //       // sorter: (a: any, b: any) => a.FollowupTrail.length - b.FollowupTrail.length,
    //       render: (_: any, record: any) => {
    //         return (
    //           <button
    //             onClick={() => {
    //               navigate("/follow-up-trail", {
    //                 state: { lead_id: record.lead_account_id },
    //               });
    //             }}
    //             className="btn btn-sm w-100"
    //             style={{
    //               whiteSpace: "nowrap",
    //               background: "#6b7280",
    //               color: "white",
    //             }}
    //           >
    //             Followup Trail
    //           </button>
    //         );
    //       },
    //     },

    //     //     {
    //     //   title: "Genter",
    //     //   dataIndex: "Gender",
    //     //   sorter: (a: any, b: any) => a.LeadOwner.length - b.LeadOwner.length,
    //     // },
    //     // {
    //     //   title: "Gender",
    //     //   dataIndex: "actions",
    //     //   render: () => (
    //     //     <div className="action-icon d-inline-flex">
    //     //     <Link
    //     //       to="#"
    //     //       className="me-2"
    //     //       data-bs-toggle="modal"
    //     //       data-bs-target="#edit_leads"
    //     //     >
    //     //       <i className="ti ti-edit" />
    //     //     </Link>
    //     //     <Link
    //     //       to="#"
    //     //       data-bs-toggle="modal"
    //     //       data-bs-target="#delete_modal"
    //     //     >
    //     //       <i className="ti ti-trash" />
    //     //     </Link>
    //     //   </div>
    //     //   ),
    //     // },
    //   ];


    const columns: ColumnsType<StaffActivity> = [
        {
            title: "Name",
            dataIndex: "name",
            render: (text: string) => text || "-",
            sorter: (a: StaffActivity, b: StaffActivity) =>
                a.name.localeCompare(b.name),
        },
        {
            title: "Mobile No",
            dataIndex: "mobile_no",
            render: (text: string) => text || "-",
        },
        {
            title: "Email",
            dataIndex: "email_id",
            render: (text: string) => text || "-",
        },
        {
            title: "Locality",
            dataIndex: "locality",
            render: (text: string) => text || "-",
        },
        {
            title: "City",
            dataIndex: "city",
            render: (text: string) => text || "-",
        },
        {
            title: "State",
            dataIndex: "state",
            render: (text: string) => text || "-",
        },
        {
            title: "Source Type",
            dataIndex: "source_type",
            render: (text: string) => text || "-",
        },
        {
            title: "Current Stage",
            dataIndex: "current_stage",
            render: (text: string) => text || "-",
        },
        {
            title: "Created On",
            dataIndex: "created_on",
            render: (date: string) =>
                date ? new Date(date).toLocaleString() : "-",
            sorter: (a: StaffActivity, b: StaffActivity) =>
                new Date(a.created_on).getTime() -
                new Date(b.created_on).getTime(),
        },
        {
            title: "Follow-up Name",
            dataIndex: "followup_name",
            render: (text: string) => text || "-",
        },
        {
            title: "Follow-up Comments",
            dataIndex: "followup_comments",
            render: (text: string) => text || "-",
        },
         {
      title: "Trails",
      dataIndex: "FollowupTrail",
      width: 150,
      render: (_: any, record: any) => {
        return (
          <button
            onClick={() => {
              navigate("/follow-up-trail", {
                state: { lead_id: record.lead_account_id },
              });
            }}
            className="btn btn-sm w-100"
            style={{
              whiteSpace: "nowrap",
              background: "#6b7280",
              color: "white",
            }}
          >
            Followup Trail
          </button>
        );
      },
    },
    ];


    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Member Activities</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item"> <Link to={routes.leaddashboard}>
                                        Dashboard
                                    </Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        <Link to={routes.ManageSalesGroup}>
                                        Mange Sales Groups
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                      <Link to={routes.ViewGroupMembers}>
                                        View Members
                                      </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Activities
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            {/* <div className="me-2 mb-2">
                   <div className="dropdown">
                     <Link
                       to="#"
                       className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                       data-bs-toggle="dropdown"
                     >
                       <i className="ti ti-file-export me-1" />
                       Export
                     </Link>
                     <ul className="dropdown-menu  dropdown-menu-end p-3">
                       <li>
                         <Link
                           to="#"
                           className="dropdown-item rounded-1"
                         >
                           <i className="ti ti-file-type-pdf me-1" />
                           Export as PDF
                         </Link>
                       </li>
                       <li>
                         <Link
                           to="#"
                           className="dropdown-item rounded-1"
                         >
                           <i className="ti ti-file-type-xls me-1" />
                           Export as Excel{" "}
                         </Link>
                       </li>
                     </ul>
                   </div>
                 </div> */}
                            {/* <div className="input-icon mb-2 position-relative">
                   <PredefinedDateRanges />
                 </div> */}
                            <div className="ms-2 head-icons">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    {/* Leads List */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Recent Activities</h5>
                            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                                {/* <div className="me-3">
              <div className="input-icon-end position-relative">
                <PredefinedDateRanges/>
                <span className="input-icon-addon">
                  <i className="ti ti-chevron-down" />
                </span>
              </div>
            </div> */}
                                <div className="dropdown me-3">
                                    {/* <Link
                to="#"
                className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Tags
              </Link> */}
                                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Closed
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Contacted
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Lost
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Not Contacted
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                {/* <div className="dropdown">
              <Link
                to="#"
                className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : Last 7 Days
              </Link>
              <ul className="dropdown-menu  dropdown-menu-end p-3">
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Recently Added
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Ascending
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Desending
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Last Month
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Last 7 Days
                  </Link>
                </li>
              </ul>
            </div> */}
                            </div>
                        </div>
                        {loading ? (
                            <div
                                className="card-body d-flex justify-content-center align-items-center"
                                style={{ minHeight: '300px' }}
                            >
                                <Loading />
                            </div>
                        ) : (
                            <div className="card-body p-0">
                                <Table dataSource={state} columns={columns} Selection={false} />
                            </div>
                        )}

                    </div>
                    {/* /Leads List */}
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
                    <p className="mb-0">{new Date().getFullYear()} © Nestfin Technology. All rights reserved.</p>
                </div>
            </div>
            {/* /Page Wrapper */}
            {/* <CrmsModal/> */}
        </>

    )
}

export default ViewMemberActivities